import { render } from "./RegisterDoctor.vue?vue&type=template&id=2e74be23&scoped=true"
import script from "./RegisterDoctor.vue?vue&type=script&lang=js"
export * from "./RegisterDoctor.vue?vue&type=script&lang=js"

import "./RegisterDoctor.vue?vue&type=style&index=0&id=2e74be23&scoped=true&lang=css"

import exportComponent from "/var/www/html2/esmanage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e74be23"]])

export default __exports__